import { Organization } from "generated/graphql";
import { replace } from "utils/Utils";
import { OrgState } from "../state";
import { updateAppInPages } from "./Common";

export function updateOrganization(
    state: OrgState,
    action: { payload: { error?: Error; organization?: Organization } }
) {
    const { error, organization } = action.payload;
    const newState: Partial<OrgState> = { error };

    if (organization) {
        newState.orgs = replace(state.orgs, organization, "organizationId");
        newState.orgPages = updateAppInPages(state, organization);

        if (state.currentOrg && state.currentOrg.organizationId === organization.organizationId) {
            newState.currentOrg = organization;
        }

        // clear out temporarily stored uploaded image on a successful save
        if (state.uploadedImages && state.uploadedImages.orgLogo) {
            newState.uploadedImages = {
                orgLogo: undefined
            };
        }
    }
    return { ...state, ...newState };
}
